import { Divider, Typography, Input, Popconfirm } from 'antd'
import { DeleteOutlined } from '@ant-design/icons';

import { Icon } from '@iconify/react';


import React, { useState } from 'react'
import { CustomInput, CustomModal, CustomTable, HeaderComp } from '../../components';
import Template from '../../Template'
const tableData = [
    {
        key: '1',
        id: '1',
        name: 'Intake',

    },
    {
        key: '2',
        id: '2',
        name: 'Contact',
    },

];
const Campaign = () => {
    const [open, setOpen] = useState(false);
    const [campaign, setCampaign] = useState('')
    const [dataSource, setDataSource] = useState(tableData)

    const emptyInput = () => setCampaign('')


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Action',
            dataIndex: 'delete_campaign',
            key: 'delete_campaign',
            align: 'center',
            render: (_, record) => {
                return (
                    <div className='flex_center'>
                        <Icon icon="mdi:border-color" style={{ cursor: 'pointer' }} fontSize={25} color="#b2b2b2" onClick={() => onEdit(record.name)} />

                        <Popconfirm title="Are you sure to delete this campaign?" onConfirm={() => onDelete(record.id)}>
                            <DeleteOutlined style={{ color: 'red', fontSize: 20, marginLeft: 10 }} />
                        </Popconfirm>
                    </div>
                );
            },
        },
    ]


    const onSearch = (v) => console.log(v.target.value);

    const onEdit = (name) => {
        console.log(name);
        setCampaign(name)
        setOpen(true)

    }

    const onChange = (e) => {
        const { value } = e.target
        setCampaign(value)
        console.log(campaign)
    }

    const onDelete = (id) => {
        console.log(id)
        setDataSource(prev => prev.filter(e => e.id !== id))

    }

    const onOk = () => {
        console.log(campaign)
        emptyInput()
    }

    const popupContent = {
        title: 'Add new campaign',
        body: <PopupContent onChange={onChange} value={campaign} />
    }

    return (
        <Template
            headerTitle={['Settings', 'Campaign']}
        >
            <div className="item_comp" >
                <HeaderComp title="Campaigns" onSearch={onSearch} btnType='popup' popupContnent={popupContent} onOk={onOk} isOpen={open} open={() => setOpen(true)} close={() => { emptyInput(); setOpen(false) }} />
                <CustomTable data={dataSource} columns={columns} />
            </div>
        </Template>
    )
}

export default Campaign

const PopupContent = ({ onChange, value }) => {
    return (
        <>
            <div className='flex_ver flex_center' style={{ width: '100%', gap: 10 }}  >
                <CustomInput type='text'
                    value={value}
                    name='name'
                    label="Campaign name"
                    onChange={onChange} />
            </div>
        </>
    )
}